import React, { useState, useEffect, Suspense } from 'react';
import IASideBar from './IASideBar';
import * as mui from '@mui/material';
import ResponsiveContainer from '../../layout/Container';
import SearchAppBar from '../../common/Appbar';
import OutlinedCard from '../../common/MediaCard';
import Separator from '../../layout/Separator';
import ReviewsRoundedIcon from '@mui/icons-material/ReviewsRounded';
import auditService from '../../../services/AuditService';
import { useParams } from 'react-router-dom';


import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import appService from '../../../services/ApplicationService';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import FolderSpecialRoundedIcon from '@mui/icons-material/FolderSpecialRounded';
import AnnouncementRoundedIcon from '@mui/icons-material/AnnouncementRounded';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import DynamicTabs from '../../common/DynamicTabs';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeveloperBoardRoundedIcon from '@mui/icons-material/DeveloperBoardRounded';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import LaptopWindowsRoundedIcon from '@mui/icons-material/LaptopWindowsRounded';
import CellTowerRoundedIcon from '@mui/icons-material/CellTowerRounded';
import DevicesOtherRoundedIcon from '@mui/icons-material/DevicesOtherRounded';
import StorageRoundedIcon from '@mui/icons-material/StorageRounded';
import StartRoundedIcon from '@mui/icons-material/StartRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import EmptyState from '../../common/EmptyState';
import EmptyState2 from '../../common/EmptyState2';
import Modal from '../../common/Modal';
import FileUploadRCM from '../../common/FileUploadRCM';
import LoadingButton from '../../common/LoadingButton';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AtSymbolIcon } from '@heroicons/react/20/solid';
import DataTable from '../../common/DataGrid';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import HRService from '../../../services/HrService';
import DataTableRCM from '../../common/DataGridRCM';
import ReportIcon from '@mui/icons-material/Report';
import { WindowSharp } from '@mui/icons-material';
import companyService from '../../../services/CompanyService';

const RiskandControlMapping = () => {
    const [selectedProject, setSelectedProject] = useState([])
    const [apps, setApps] = useState([])
    const { id } = useParams();

    const [open, setOpen] = React.useState(true);
    const [sidebarVisible, setSidebarVisible] = useState(false);

    const [openRCMModal, setOpenRCMModal] = useState(false);

    const [rcmUpload, setRCMUpload] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isUploadComplete, setIsUploadComplete] = useState(false);
    const [validationError, setValidationError] = useState('');

    const [hrList, setHRList] = useState([]);
    const [rcmData, setRCMData] = useState(false);

    const [loading, setLoading] = useState(true);

    const [relevantRiskCount, setRelevantRiskCount] = useState(0);
    const [relevantControlsCount, setRelevantControlsCount] = useState(0);
    const [openRiskCount, setOpenRiskCount] = useState(0);


    const handleClick = () => {
        setOpen(!open);
    };


    const handleCloseRCMModal = (event, reason) => {
        // Only prevent closing on backdrop click if data has been uploaded
        if (reason === 'backdropClick' && rcmUpload && rcmUpload.length > 0) {
            return; // Don't close the modal if data has been uploaded
        }
        
        // Reset upload state when closing the modal
        if (!isLoading && !isUploadComplete) {
            setRCMUpload([]);
            setValidationError('');
        }
        
        setOpenRCMModal(false);
    };


    useEffect(() => {

        const fetchProjectbyID = async () => {
            try {
                const projectRecord = await auditService.fetchProjectsById(id)
                if (projectRecord) {
                    setSelectedProject(projectRecord);

                    const appRecord = await appService.fetchAppsByCompany(projectRecord.COMPANY_ID)

                    if (appRecord) {
                        setApps(appRecord);
                    }

                    // Get the company record to access the actual COMPANY_ID field
                    if (projectRecord.COMPANY_ID) {
                        try {
                            const companyRecord = await companyService.fetchCompanyById(projectRecord.COMPANY_ID);
                            if (companyRecord && companyRecord.COMPANY_ID) {
                                // Store the actual COMPANY_ID in the selectedProject object
                                setSelectedProject(prev => ({
                                    ...prev,
                                    COMPANY_ID_STRING: companyRecord.COMPANY_ID
                                }));
                            }
                        } catch (companyError) {
                            console.error('Error fetching company details:', companyError);
                        }
                    }

                    const riskMapping = await auditService.fetchRiskMappingbyCompany(projectRecord.COMPANY_ID)

                    if (riskMapping) {
                        setRCMData(riskMapping)
                        setLoading(false)
                    }
                }

            } catch (fetchError) {
                console.error('Error fetching project:', fetchError);
                setLoading(false)
                setRCMData([])
            }
        }

        const fetchControlOwner = async () => {
            try {
                const hrList = await HRService.fetchHRRecordByEmail();
                if (hrList) {
                    // Use a Set to store unique emails
                    const uniqueEmailList = Array.from(
                        new Map(
                            hrList.map(item => [item.EMAIL_ADDRESS, item])
                        ).values()
                    );

                    setHRList(uniqueEmailList)

                }
            } catch (error) {
                console.error('Error fetching role owner:', error);
            }
        };
        fetchControlOwner();
        fetchProjectbyID();
    }, []);

    const icon = isLoading ? null : isUploadComplete ? (
        <CloudDoneIcon style={{ color: 'white' }} />
    ) : (
        <CloudUploadIcon style={{ color: 'white' }} />
    );

    const getIconForType = (appType) => {
        switch (appType) {
            case 'Application':
                return <DeveloperBoardRoundedIcon style={{ color: '#046FB2', marginRight: '5px' }} />;
            case 'Database':
                return <StorageRoundedIcon style={{ color: '#046FB2', marginRight: '5px' }} />; // Replace with actual icon
            case 'Operating System':
                return <LaptopWindowsRoundedIcon style={{ color: '#046FB2', marginRight: '5px' }} />; // Replace with actual icon
            case 'Network':
                return <CellTowerRoundedIcon style={{ color: '#046FB2', marginRight: '5px' }} />; // Replace with actual icon   
            default:
                return <DevicesOtherRoundedIcon style={{ color: '#046FB2', marginRight: '5px' }} />;
        }
    };

    const getIcon = (appType) => {
        switch (appType) {
            case 'Application':
                return DeveloperBoardRoundedIcon;
            case 'Database':
                return StorageRoundedIcon;
            case 'Operating System':
                return LaptopWindowsRoundedIcon;
            case 'Network':
                return CellTowerRoundedIcon;
            default:
                return DevicesOtherRoundedIcon;
        }
    };

    const handleRiskAssessment = (appId) => {
        return () => {
            // Open a new tab and navigate to the specified URL using the new RiskMappingStepper
            window.open(`/audit/riskmappingstepper/application/${selectedProject.COMPANY_ID}/${appId}`, '_blank');
        };
    };


    const handleOnRCMData = (data) => {
        setRCMUpload(data); // Update the parent's state with the data
        setIsUploadComplete(false);
        setValidationError('');
    };

    const handleToggle = () => {
        setSidebarVisible(false); // Toggle the open state
    };

    const handleButtonClick = async () => {
        if (!rcmUpload || rcmUpload.length === 0) {
            setValidationError('No data available to upload. Please select a file first.');
            return; // Don't proceed if no data is available
        }
        
        setIsLoading(true);
        setIsUploadComplete(false);
        setValidationError('');

        try {
            // Add COMPANY_ID to each item in rcmUpload if not already present
            const enrichedRcmUpload = rcmUpload.map(item => ({
                ...item,
                // Ensure COMPANY_ID is set to the project's company ID if missing
                // Use the string COMPANY_ID if available, else fall back to the UUID
                COMPANY_ID: item.COMPANY_ID || selectedProject.COMPANY_ID_STRING || selectedProject.COMPANY_ID
            }));
            
            const risk_mapping = await auditService.createRiskMapping(enrichedRcmUpload);

            if (risk_mapping) {
                setRCMData(risk_mapping);

                setTimeout(() => {
                    setIsLoading(false);  // End loading
                    setIsUploadComplete(true);  // Mark upload as complete 
                }, 1500);

                setTimeout(() => {
                    handleCloseRCMModal();
                    window.location.reload(); 
                }, 2500);
            }
        } catch (error) {
            console.error('Error uploading RCM data:', error);
            setIsLoading(false);
            setValidationError(error.response?.data?.message || error.message || 'Failed to upload RCM data');
            // Handle error case
        }
    };

    const items = apps.map((app) => ({
        id: app.id,
        title: app.APP_NAME,            // Use APP_NAME as the title
        description: app.APP_DESCRIPTION,  // Use APP_DESCRIPTION as the description
        icon: getIcon(app.APP_TYPE),              // You can change this to another icon based on app data if needed
        background: 'bg-blue-500',     // You can also customize the background color based on the app
    }));

    const handleItemClick = (item) => {
        window.open(`/audit/riskmappingstepper/application/${selectedProject.COMPANY_ID}/${item.id}`, '_blank');
        // You can perform any other action here, such as updating state or navigating
    };

    const handleOpenRCMModal = (item) => {
        setOpenRCMModal(true)
    };

    const handleWorkPaperNavigate = async (item) => {
        
        try {
            const workpaper = await auditService.fetchWorkpapersByAppControl(item.appID, selectedProject.COMPANY_ID,  item.controlID);
            if (workpaper && workpaper.length > 0) {
                window.open(`/audit/workpapers/project/${selectedProject.id}/app/${item.appID}/control/${workpaper[0].id}`, '_blank');
            }
        } catch (error) {
            console.error('Error fetching workpaper:', error);
        }
    };


    const columns = [
        { field: 'id', headerName: '#', width: 70 }, // Increased width for better clarity
        { field: 'APP_NAME', headerName: 'Application Name', minWidth: 200 }, // Fixed width
        { 
            field: 'CONTROL_ID', 
            headerName: 'Control ID', 
            minWidth: 100,
            renderCell: (params) => (
                <mui.Link
                    component="button"
                    onClick={() => {
                        handleWorkPaperNavigate(params.row)
                    }}
                >
                    {params.value}
                </mui.Link>
            )
        }, // Fixed width
        { field: 'CONTROL_NAME', headerName: 'Control Name', minWidth: 250 }, // Fixed width
        { field: 'CONTROL_DESCRIPTION', headerName: 'Control Description', minWidth: 450 }, // Fixed width
        { field: 'CONTROL_FREQUENCY', headerName: 'Frequency', minWidth: 150 }, // Fixed width
        { field: 'CONTROL_CATEGORY', headerName: 'Category', minWidth: 150 }, // Fixed width
        { field: 'CONTROL_TYPE', headerName: 'Type', minWidth: 150 }, // Fixed width
        { field: 'NUMBER_OF_RISKS', headerName: 'Relevant Risk', minWidth: 150 }, // Fixed width
        { field: 'RISK_ID', headerName: 'Relevant Details', minWidth: 250 }, // Fixed width6
        { field: 'IS_KEY', headerName: 'Key/Non-Key', minWidth: 150 }, // Fixed width
        { field: 'CONTROL_OWNER', headerName: 'Control Owner', minWidth: 200 }, // Fixed width
        { field: 'CONTROL_PERFORMER', headerName: 'Control Performer', minWidth: 200 }, // Fixed width
    ];

    const rows = Array.isArray(rcmData.controls_data) ? rcmData.controls_data.reduce((acc, item) => {

        // Process each control's details
        item.CONTROL_DETAILS.forEach(control => {
            // Create a unique key by combining CONTROL_ID and APP_NAME
            const uniqueKey = `${control.CONTROL_ID}-${item.APP_NAME}`;

            // Check if the control with the same CONTROL_ID and APP_NAME already exists in the accumulator
            const existingControl = acc.find(row => row.CONTROL_ID === control.CONTROL_ID && row.APP_NAME === item.APP_NAME);

            if (existingControl) {
                // If the control already exists, add the RISK_ID and increment the risk count
                const riskIds = existingControl.RISK_ID.split(', ').concat(item.RISK_ID).filter((value, index, self) => self.indexOf(value) === index); // Ensure unique risk IDs
                existingControl.RISK_ID = riskIds.join(', '); // Join the unique RISK_IDs
                existingControl.NUMBER_OF_RISKS = riskIds.length; // Set the number of unique risks
            } else {
                // If the control doesn't exist, create a new row with the risk count
                acc.push({
                    id: acc.length + 1, // Incrementing id for each new row
                    APP_NAME: item.APP_NAME || '-',
                    appID: item.appID || '-',
                    CONTROL_ID: control.CONTROL_ID,
                    CONTROL_NAME: control.CONTROL_TITLE || '-',
                    CONTROL_DESCRIPTION: control.CONTROL_DESCRIPTION || '-',
                    CONTROL_CATEGORY: control.CONTROL_CATEGORY || '-',
                    CONTROL_FREQUENCY: item.CONTROL_FREQUENCY || '-',
                    CONTROL_TYPE: control.CONTROL_TYPE || '-',
                    RISK_ID: item.RISK_ID,
                    IS_KEY: item.IS_KEY ? 'Key' : 'Non-Key',
                    riskmappingID: item.id,
                    CONTROL_OWNER: item.CONTROL_OWNER, // Assuming CONTROL_OWNER exists on item level
                    CONTROL_PERFORMER: item.CONTROL_PERFORMER, // Assuming CONTROL_PERFORMER exists on item level
                    NUMBER_OF_RISKS: 1,
                    controlID: control.id // Store control.id in controlID field
                });
            }
        });

        return acc;
    }, []) : [];

    // Sort the rows by APP_NAME and CONTROL_ID
    rows.sort((a, b) => {
        // First, compare by APP_NAME
        if (a.APP_NAME < b.APP_NAME) return -1;
        if (a.APP_NAME > b.APP_NAME) return 1;

        // If APP_NAME is the same, compare by CONTROL_ID
        if (a.CONTROL_ID < b.CONTROL_ID) return -1;
        if (a.CONTROL_ID > b.CONTROL_ID) return 1;

        return 0;
    });

    // Reassign the `id` property to match the sorted order (sequential)
    rows.forEach((row, index) => {
        row.id = index + 1; // Recalculate `id` based on the sorted order
    });




    const renderRCMButton = (params) => {
        const app = params.row;
        const readyforaudit = app.geninfo && app.userdata && app.process;

        return (

            <Tooltip title="View Details" arrow>
                <mui.IconButton
                    size="small"
                    onClick={(event) => handleClick(event, app)}
                >
                    <OpenInNewIcon sx={{ fontSize: '18px' }} />
                </mui.IconButton>
            </Tooltip>

        );
    };

    const columnsWithActions = [
        ...columns,
        {
            field: 'actions',
            headerName: 'Manage',
            width: 200,
            sortable: false,
            renderCell: renderRCMButton,
        },

    ];

    const [isOverflowing, setIsOverflowing] = useState(true);

    // Callback to handle overflow state change
    const handleOverflowChange = (overflowStatus) => {
        setIsOverflowing(overflowStatus);
    };

    const tabs = [
        {
            value: '1',
            label: 'Risks and Controls Matrix',
            content: (

                loading ? (
                    <Suspense fallback={<div>Loading...</div>}>
                        <div>Loading...</div>
                    </Suspense>
                ) : !rcmData || rcmData.length === 0 ? (
                    <div>
                        <EmptyState title={'No Risk and Controls Matrix'} />
                        <EmptyState2
                            items={items}
                            description={'You haven\'t created a risk and control mapping yet. Get started by individually mapping risk and control by application or perform a bulk upload of the risk and controls.'}
                            link={handleOpenRCMModal}
                            onItemClick={handleItemClick}
                            otherLinkDescription={'Or start a bulk upload of risk and controls mapping for multiple applications'}
                        />
                    </div>
                ) : (
                    <mui.Box sx={{ 
                        backgroundColor: '#f8fafc', 
                        borderRadius: 3,
                        minHeight: '80vh',
                        height: 'auto', // Allow height to adjust based on content
                        boxShadow: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
                        p: 2 // Added padding to fix spacing issue
                    }}>
                        <mui.Paper 
                            elevation={0}
                            sx={{ 
                                p: 3,
                                height: '800px', // Fixed height for the container
                                maxHeight: 'calc(100vh - 200px)', // Ensure it doesn't exceed viewport height
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundColor: 'transparent'
                            }}
                        >
                            <mui.Box sx={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                height: '100%',
                                overflow: 'hidden' // Ensure content doesn't overflow
                            }}>
                                <mui.Box sx={{ 
                                    display: 'flex',
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    alignItems: { xs: 'flex-start', sm: 'center' },
                                    justifyContent: 'space-between',
                                    mb: 3
                                }}>
                                    <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <mui.Box 
                                            sx={{ 
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '4px',
                                                bgcolor: 'rgba(4, 111, 178, 0.06)',
                                                p: 0.8,
                                                mr: 1.5,
                                                color: '#046FB2'
                                            }}
                                        >
                                            <AssignmentTurnedInRoundedIcon fontSize="small" />
                                        </mui.Box>
                                        <mui.Typography 
                                            variant="h6" 
                                            sx={{ 
                                                fontWeight: 500, 
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                lineHeight: 1.3
                                            }}
                                        >
                                            Risk and Control Matrix
                                        </mui.Typography>
                                    </mui.Box>
                                    <mui.Box sx={{ mt: { xs: 2, sm: 0 }, display: 'flex', gap: 1 }}>
                                        <mui.Button
                                            variant="outlined"
                                            size="small"
                                            startIcon={<GetAppIcon />}
                                            sx={{ 
                                                textTransform: 'none',
                                                borderColor: 'rgba(0,0,0,0.12)',
                                                color: 'text.primary',
                                                boxShadow: 'none',
                                                borderRadius: '6px',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                                }
                                            }}
                                        >
                                            Export
                                        </mui.Button>
                                        <mui.Button
                                            variant="contained"
                                            size="small"
                                            startIcon={<CloudUploadIcon />}
                                            onClick={handleOpenRCMModal}
                                            sx={{ 
                                                textTransform: 'none', 
                                                backgroundColor: '#046FB2',
                                                boxShadow: 'none',
                                                borderRadius: '6px',
                                                '&:hover': {
                                                    backgroundColor: '#035d94',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                }
                                            }}
                                        >
                                            Upload Controls
                                        </mui.Button>
                                    </mui.Box>
                                </mui.Box>
                                <mui.Box sx={{ 
                                    flexGrow: 1,
                                    height: 'calc(100% - 60px)', // Reserve space for the header
                                    overflow: 'hidden' // Ensure no overflow
                                }}>
                                    <DataTableRCM
                                        rows={rows}
                                        columns={columns}
                                        columnsWithActions={columnsWithActions}
                                        height={'100%'} // Use 100% to fill the container
                                        sx={{
                                            height: '100%',
                                            '& .MuiDataGrid-root': {
                                                border: 'none',
                                                backgroundColor: 'white',
                                                overflow: 'hidden',
                                                '&:hover': {
                                                    borderColor: 'rgba(25, 118, 210, 0.12)'
                                                }
                                            }
                                        }}
                                    />
                                </mui.Box>
                            </mui.Box>
                        </mui.Paper>
                    </mui.Box>
                )
            )
        },
        {
            value: '2',
            label: 'Map Risk and Controls by Applications',
            content: (
                <mui.Box sx={{ padding: 3 }}> {/* Added padding to fix spacing issue */}
                    <mui.Box sx={{ 
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        mb: 3,
                        mt: 1
                    }}>
                        <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <mui.Box 
                                sx={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    bgcolor: 'rgba(4, 111, 178, 0.06)',
                                    p: 0.8,
                                    mr: 1.5,
                                    color: '#046FB2'
                                }}
                            >
                                <GridViewRoundedIcon fontSize="small" />
                            </mui.Box>
                            <mui.Typography 
                                variant="h6" 
                                sx={{ 
                                    fontWeight: 500, 
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    lineHeight: 1.3
                                }}
                            >
                                Application Risk Mapping
                            </mui.Typography>
                        </mui.Box>
                        <mui.Typography 
                            variant="body2" 
                            sx={{ 
                                color: 'text.secondary',
                                mt: { xs: 1, sm: 0 },
                                maxWidth: '500px',
                                fontSize: '0.875rem'
                            }}
                        >
                            Select an application to begin risk assessment and control mapping
                        </mui.Typography>
                    </mui.Box>

                    <mui.Box sx={{ 
                        backgroundColor: 'transparent', 
                        overflow: 'auto', 
                        marginTop: '10px',
                        pb: 2 // Added bottom padding
                    }}>
                        {apps.length === 0 ? (
                            <mui.Box sx={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                backgroundColor: 'transparent',
                                borderRadius: 1,
                                padding: 4,
                                border: '1px dashed rgba(0,0,0,0.08)'
                            }}>
                                <mui.Box sx={{ mb: 2, opacity: 0.4 }}>
                                    <DevicesOtherRoundedIcon sx={{ fontSize: 36, color: 'text.secondary' }} />
                                </mui.Box>
                                <mui.Typography variant="body1" sx={{ mb: 1, fontWeight: 400, color: 'text.secondary' }}>
                                    No Applications Found
                                </mui.Typography>
                                <mui.Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: 400, opacity: 0.7 }}>
                                    There are no applications available for risk assessment and control mapping.
                                </mui.Typography>
                            </mui.Box>
                        ) : (
                            <mui.Grid container spacing={2}>
                                {apps.map((app) => {
                                    const riskperApp = rcmData?.controls_data?.filter(item => item.APP_NAME === app.APP_NAME);
                                    const riskCount = Array.isArray(rcmData.controls_data)
                                        ? rcmData.controls_data?.filter(item => item.APP_NAME === app.APP_NAME).length
                                        : 0;
                                    
                                    const unmappedRiskCount = Array.isArray(riskperApp)
                                        ? riskperApp?.filter(item => !item.CONTROL_ID || (Array.isArray(item.CONTROL_ID) && item.CONTROL_ID.length === 0)).length
                                        : 0;
                                    
                                    const mappedRiskCount = riskCount - unmappedRiskCount;
                                    
                                    // Calculate risk mapping percentage
                                    const mappingPercentage = riskCount > 0 ? Math.round((mappedRiskCount / riskCount) * 100) : 0;
                                    
                                    // Determine status color based on percentage
                                    const statusColor = mappingPercentage === 100 ? '#10b981' : 
                                                        mappingPercentage >= 75 ? '#22c55e' : 
                                                        mappingPercentage >= 50 ? '#f59e0b' : 
                                                        mappingPercentage > 0 ? '#f97316' : '#ef4444';
                                    
                                    return (
                                        <mui.Grid item xs={12} sm={6} md={4} lg={3} key={app.id}>
                                            <mui.Paper 
                                                elevation={0}
                                                sx={{ 
                                                    borderRadius: 1, // Added better border radius
                                                    border: '1px solid',
                                                    borderColor: 'rgba(0,0,0,0.04)',
                                                    transition: 'all 0.15s ease',
                                                    backgroundColor: 'white', // Changed to white background
                                                    height: '100%',
                                                    '&:hover': {
                                                        borderColor: 'rgba(0,0,0,0.09)',
                                                        backgroundColor: 'rgba(0,0,0,0.01)',
                                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
                                                    }
                                                }}
                                            >
                                                <mui.Box sx={{ padding: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                    <mui.Box sx={{ 
                                                        display: 'flex', 
                                                        justifyContent: 'space-between', 
                                                        alignItems: 'flex-start',
                                                        mb: 2,
                                                        pb: 1.5,
                                                        borderBottom: '1px solid rgba(0,0,0,0.03)'
                                                    }}>
                                                        <mui.Typography 
                                                            variant="subtitle1" 
                                                            component="h3" 
                                                            sx={{ 
                                                                color: 'text.primary',
                                                                fontWeight: 500,
                                                                lineHeight: 1.3,
                                                                fontSize: '1rem'
                                                            }}
                                                        >
                                                            {app.APP_NAME || 'N/A'}
                                                        </mui.Typography>
                                                        <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            {getIconForType(app.APP_TYPE)}
                                                            <mui.Typography 
                                                                variant="caption" 
                                                                sx={{ 
                                                                    color: 'text.secondary',
                                                                    fontSize: '0.8rem'
                                                                }}
                                                            >
                                                                {app.APP_TYPE || 'N/A'}
                                                            </mui.Typography>
                                                        </mui.Box>
                                                    </mui.Box>
                                                    
                                                    <mui.Box sx={{ mb: 2 }}>
                                                        <mui.Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.8 }}>
                                                            <mui.Typography 
                                                                variant="body2" 
                                                                sx={{ color: 'text.secondary', fontSize: '0.8rem' }}
                                                            >
                                                                Mapping Progress
                                                            </mui.Typography>
                                                            <mui.Typography 
                                                                variant="body2" 
                                                                sx={{ 
                                                                    color: mappingPercentage === 100 ? '#10b981' : 
                                                                           mappingPercentage >= 50 ? '#f59e0b' : 
                                                                           'text.secondary',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 500
                                                                }}
                                                            >
                                                                {mappingPercentage}%
                                                            </mui.Typography>
                                                        </mui.Box>
                                                        <mui.LinearProgress 
                                                            variant="determinate" 
                                                            value={mappingPercentage}
                                                            sx={{
                                                                height: 4,
                                                                borderRadius: 2,
                                                                bgcolor: 'rgba(0,0,0,0.03)',
                                                                '& .MuiLinearProgress-bar': {
                                                                    bgcolor: statusColor
                                                                }
                                                            }}
                                                        />
                                                    </mui.Box>
                                                    
                                                    <mui.Box sx={{ display: 'flex', alignItems: 'center', mb: 'auto', mt: 1 }}>
                                                        <Tooltip title="Total number of risks identified for this application" arrow>
                                                            <mui.Box 
                                                                sx={{ 
                                                                    display: 'flex', 
                                                                    alignItems: 'center', 
                                                                    mr: 3,
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                <WarningAmberRoundedIcon 
                                                                    fontSize="small" 
                                                                    sx={{ 
                                                                        color: 'warning.main', 
                                                                        fontSize: '0.9rem',
                                                                        opacity: 0.8,
                                                                        mr: 0.5
                                                                    }} 
                                                                />
                                                                <mui.Typography 
                                                                    variant="body2" 
                                                                    sx={{ 
                                                                        color: 'text.secondary', 
                                                                        fontSize: '0.85rem' 
                                                                    }}
                                                                >
                                                                    {riskCount}
                                                                </mui.Typography>
                                                            </mui.Box>
                                                        </Tooltip>
                                                        
                                                        <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Tooltip title="Risks with mapped controls" arrow>
                                                                <mui.Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                                                                    <GppGoodRoundedIcon 
                                                                        fontSize="small" 
                                                                        sx={{ 
                                                                            color: '#046FB2', 
                                                                            fontSize: '0.9rem',
                                                                            opacity: 0.8,
                                                                            mr: 0.5
                                                                        }} 
                                                                    />
                                                                    <mui.Typography 
                                                                        variant="body2" 
                                                                        sx={{ 
                                                                            color: 'text.secondary', 
                                                                            fontSize: '0.85rem'
                                                                        }}
                                                                    >
                                                                        {mappedRiskCount}
                                                                    </mui.Typography>
                                                                </mui.Box>
                                                            </Tooltip>
                                                            
                                                            <Tooltip title="Unmapped risks (requiring controls)" arrow>
                                                                <mui.Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <ReportIcon 
                                                                        fontSize="small" 
                                                                        sx={{ 
                                                                            color: 'error.main', 
                                                                            fontSize: '0.9rem',
                                                                            opacity: 0.8,
                                                                            mr: 0.5
                                                                        }} 
                                                                    />
                                                                    <mui.Typography 
                                                                        variant="body2" 
                                                                        sx={{ 
                                                                            color: 'text.secondary', 
                                                                            fontSize: '0.85rem' 
                                                                        }}
                                                                    >
                                                                        {unmappedRiskCount}
                                                                    </mui.Typography>
                                                                </mui.Box>
                                                            </Tooltip>
                                                        </mui.Box>
                                                    </mui.Box>
                                                    
                                                    <mui.Button
                                                        variant="text"
                                                        size="medium"
                                                        endIcon={<OpenInNewRoundedIcon sx={{ fontSize: '1rem' }} />}
                                                        onClick={handleRiskAssessment(app.id)}
                                                        sx={{ 
                                                            mt: 2,
                                                            pt: 1.5,
                                                            borderTop: '1px solid rgba(0,0,0,0.03)',
                                                            textTransform: 'none',
                                                            justifyContent: 'space-between',
                                                            color: 'text.secondary',
                                                            fontSize: '0.85rem',
                                                            fontWeight: 400,
                                                            px: 0.5,
                                                            '&:hover': {
                                                                backgroundColor: 'transparent',
                                                                color: '#046FB2'
                                                            }
                                                        }}
                                                    >
                                                        Start Assessment
                                                    </mui.Button>
                                                </mui.Box>
                                            </mui.Paper>
                                        </mui.Grid>
                                    );
                                })}
                            </mui.Grid>
                        )}
                    </mui.Box>
                </mui.Box>
            ),
        },
    ]


    const customMainContent = (
        <div>
            <ResponsiveContainer>
                <mui.Box sx={{ 
                    padding: { xs: '16px', sm: '24px' },
                    maxWidth: '1600px',
                    margin: '0 auto'
                }}>
                    <mui.Breadcrumbs 
                        aria-label="breadcrumb"
                        sx={{
                            '& .MuiLink-root': {
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.secondary',
                                fontSize: '0.875rem',
                                transition: 'color 0.2s ease',
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }
                        }}
                    >
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            <i className="material-icons">home</i>
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            My Dashboard
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href={`/Audit/Projects/${selectedProject.id}`}>
                            {selectedProject.AUDIT_NAME}
                        </mui.Link>
                        <mui.Typography color="text.primary">Risk and Control Mapping</mui.Typography>
                    </mui.Breadcrumbs>

                    <mui.Box sx={{ 
                        display: 'flex', 
                        alignItems: 'flex-start', 
                        mb: 4, 
                        mt: 3,
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 2, sm: 0 }
                    }}>
                        <ReviewsRoundedIcon sx={{ 
                            fontSize: 28, 
                            color: 'primary.main', 
                            mr: { xs: 0, sm: 2.5 },
                            opacity: 0.9
                        }} />
                        <mui.Box sx={{ flex: 1 }}>
                            <mui.Typography 
                                variant="h4" 
                                component="h1" 
                                sx={{ 
                                    fontWeight: 600, 
                                    color: 'text.primary', 
                                    mb: 1,
                                    fontSize: { xs: '1.5rem', sm: '2rem' }
                                }}
                            >
                                Risk and Control Mapping
                            </mui.Typography>
                            <mui.Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 2,
                                flexWrap: 'wrap'
                            }}>
                                <mui.Chip
                                    size="small"
                                    label={selectedProject?.AUDIT_TYPE || 'N/A'}
                                    sx={{ 
                                        backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                        color: 'primary.main',
                                        fontWeight: 500,
                                        borderRadius: '6px',
                                        height: '24px'
                                    }}
                                />
                                <mui.Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 1 
                                }}>
                                    <span style={{ 
                                        width: 6, 
                                        height: 6, 
                                        borderRadius: '50%',
                                        backgroundColor: selectedProject?.STATUS === 'Active' ? '#10b981' : 
                                                      selectedProject?.STATUS === 'Archived' ? '#6b7280' :
                                                      selectedProject?.STATUS === 'On-Hold' ? '#ef4444' : '#f59e0b',
                                        display: 'inline-block'
                                    }} />
                                    <mui.Typography 
                                        variant="body2" 
                                        sx={{ 
                                            color: 'text.secondary',
                                            fontSize: '0.8125rem'
                                        }}
                                    >
                                        {selectedProject?.STATUS || 'N/A'}
                                    </mui.Typography>
                                </mui.Box>
                            </mui.Box>
                        </mui.Box>
                    </mui.Box>

                    {loading ? (
                        <mui.Box 
                            sx={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                height: '60vh',
                                backgroundColor: '#ffffff',
                                borderRadius: 2,
                                boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)',
                                border: '1px solid',
                                borderColor: 'rgba(0,0,0,0.06)'
                            }}
                        >
                            <mui.Box sx={{ textAlign: 'center' }}>
                                <mui.CircularProgress 
                                    size={40} 
                                    thickness={4}
                                    sx={{
                                        color: 'primary.main',
                                        animation: 'pulse 1.5s ease-in-out infinite',
                                    }}
                                />
                                <mui.Typography 
                                    variant="body1" 
                                    sx={{ 
                                        mt: 2, 
                                        color: 'text.secondary',
                                        fontWeight: 500
                                    }}
                                >
                                    Loading Risk and Control Matrix...
                                </mui.Typography>
                            </mui.Box>
                        </mui.Box>
                    ) : (
                        <mui.Box sx={{ 
                            backgroundColor: '#ffffff', 
                            borderRadius: 2,
                            minHeight: '80vh',
                            border: '1px solid',
                            borderColor: 'rgba(0,0,0,0.06)',
                            boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)'
                        }}>
                            <mui.Paper 
                                elevation={0}
                                sx={{ 
                                    p: { xs: 2, sm: 3 },
                                    height: '100%',
                                    backgroundColor: 'transparent'
                                }}
                            >
                                <mui.Grid
                                    container spacing={3}
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                >
                                    <mui.Grid item
                                        xs={sidebarVisible ? 3 : false}
                                        sx={{
                                            flexDirection: 'column',
                                            transition: 'transform 0.3s ease, width 0.3s ease', // Smooth transition for both transform and width
                                            transform: sidebarVisible ? 'translateX(0)' : 'translateX(-100%)',
                                            display: sidebarVisible ? 'block' : 'none'
                                        }}>
                                        <mui.Paper sx={{ flex: 1, overflow: 'auto' }}>
                                            <List
                                                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                                                component="nav"
                                                aria-labelledby="nested-list-subheader"
                                                subheader={
                                                    <ListSubheader component="div" id="nested-list-subheader" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        Quick Links
                                                        <mui.Box>
                                                            <mui.IconButton onClick={handleToggle}>
                                                                {sidebarVisible ? <CloseIcon /> : <CloseIcon />}
                                                            </mui.IconButton>
                                                        </mui.Box>
                                                    </ListSubheader>
                                                }
                                            >
                                                <ListItemButton onClick={handleClick}>
                                                    <ListItemIcon>
                                                        <GridViewRoundedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Applications" />
                                                    {open ? <ExpandLess /> : <ExpandMore />}
                                                </ListItemButton>
                                                <Collapse in={open} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        {apps.map((app) => (
                                                            <React.Fragment key={app.id}>
                                                                <ListItemButton sx={{ pl: 5 }}>
                                                                    <ListItemIcon>
                                                                        <RadioButtonCheckedRoundedIcon style={{ fontSize: '12px', color: 'green' }} />
                                                                    </ListItemIcon>
                                                                    <ListItemText primary={app.APP_NAME} style={{ fontSize: '10px' }} />
                                                                </ListItemButton>
                                                            </React.Fragment>
                                                        ))}
                                                    </List>
                                                </Collapse>
                                                <Divider />
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <AssignmentTurnedInRoundedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Planning Documents" />
                                                </ListItemButton>
                                                <Divider />
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <FolderSpecialRoundedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Workpapers" />
                                                </ListItemButton>
                                                <Divider />
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <AnnouncementRoundedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Deficiencies" />
                                                </ListItemButton>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <GetAppIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Audit Request" />
                                                </ListItemButton>
                                            </List>
                                        </mui.Paper>
                                    </mui.Grid>

                                    <mui.Grid item
                                        xs={12}
                                    >
                                        <mui.Paper>
                                            <DynamicTabs tabs={tabs} />
                                        </mui.Paper>
                                    </mui.Grid>

                                </mui.Grid>
                            </mui.Paper>
                        </mui.Box>
                    )}
                </mui.Box>
            </ResponsiveContainer>
            <Modal
                open={openRCMModal}
                size={'lg'}
                onClose={handleCloseRCMModal}
                header={
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                        padding: '16px 24px',
                        backgroundColor: '#fafafa' 
                    }}>
                        <CloudUploadIcon 
                            style={{ 
                                marginRight: '12px', 
                                color: '#046FB2',
                                fontSize: '22px' 
                            }} 
                        />
                        <span style={{ 
                            fontSize: '18px', 
                            fontWeight: 500,
                            color: '#333' 
                        }}>
                            Upload Risk and Controls Matrix
                        </span>
                    </div>
                }
                body={
                    <div style={{ padding: '0', margin: '0' }}>
                        <FileUploadRCM 
                            onRCMDataChange={handleOnRCMData} 
                            companyId={selectedProject?.COMPANY_ID_STRING || selectedProject?.COMPANY_ID || ''}
                            validAppNames={apps || []}
                        />
                        {validationError && (
                            <mui.Alert 
                                severity="error" 
                                sx={{ 
                                    mx: 3, 
                                    my: 2, 
                                    borderRadius: 1,
                                    '& .MuiAlert-icon': {
                                        color: '#d32f2f'
                                    }
                                }}
                            >
                                {validationError}
                            </mui.Alert>
                        )}
                    </div>
                }
                footer={
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end', 
                        width: '100%', 
                        gap: '12px',
                        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
                        padding: '16px 24px',
                        backgroundColor: '#fafafa'
                    }}>
                        <mui.Button 
                            onClick={handleCloseRCMModal} 
                            variant="outlined"
                            size="medium"
                            sx={{ 
                                textTransform: 'none',
                                borderColor: 'rgba(0,0,0,0.12)',
                                color: 'text.primary',
                                borderRadius: '6px',
                                '&:hover': {
                                    borderColor: 'rgba(0,0,0,0.24)',
                                    backgroundColor: 'rgba(0,0,0,0.04)'
                                }
                            }}
                        >
                            Cancel
                        </mui.Button>

                        <LoadingButton
                            label={isLoading ? 'Uploading...' : isUploadComplete ? 'Upload Complete' : 'Upload RCM'}
                            icon={icon}
                            isLoading={isLoading}
                            onClick={handleButtonClick}
                            disabled={!rcmUpload || rcmUpload.length === 0}
                            customStyles={{ 
                                backgroundColor: isUploadComplete ? '#4caf50' : '#046FB2',
                                color: 'white',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: isUploadComplete ? '#43a047' : '#035d94'
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                    color: 'rgba(0, 0, 0, 0.26)'
                                },
                                borderRadius: '6px',
                                boxShadow: 'none',
                                padding: '6px 16px'
                            }}
                        />
                    </div>
                }
                style={{ 
                    '& .MuiDialog-paper': { 
                        borderRadius: '8px',
                        overflow: 'hidden'
                    },
                    '& .MuiDialogContent-root': {
                        padding: '0px'
                    },
                    '& .MuiDialogActions-root': {
                        padding: '0px'
                    }
                }}
            />
        </div>
    );

    return (
        <Suspense fallback={
            <mui.Box 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100vh',
                    backgroundColor: '#f8fafc'
                }}
            >
                <mui.Box sx={{ textAlign: 'center' }}>
                    <mui.CircularProgress 
                        size={40} 
                        thickness={4}
                        sx={{
                            color: 'primary.main',
                            animation: 'pulse 1.5s ease-in-out infinite',
                        }}
                    />
                    <mui.Typography 
                        variant="body1" 
                        sx={{ 
                            mt: 2, 
                            color: 'text.secondary',
                            fontWeight: 500
                        }}
                    >
                        Loading Risk and Control Matrix...
                    </mui.Typography>
                </mui.Box>
            </mui.Box>
        }>
            <div>
                <IASideBar mainContent={customMainContent} />
            </div>
        </Suspense>
    );
}
export default RiskandControlMapping;